/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment'
import React, {useEffect, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import {
  fetchData,
  formatNumber,
  getNumberOfDays,
  getNumberOfHoursFromDateTime,
  getTranslatedValue,
  toasterrormsg,
} from '../../../../reusable'
import {Tr} from '../../../../_metronic/i18n/Tr'
import {PageTitle} from '../../../../_metronic/layout/core'
import {TablesWidget14} from '../../../../_metronic/partials/widgets'
import {useLang} from '../../../../_metronic/i18n/Metronici18n'

const ViewHotelBookingDetails = () => {
  const t = Tr()
  const lang = useLang()
  //overview states
  const navigate = useNavigate()
  const categoryId = sessionStorage.getItem('categoryId')
  useEffect(() => {
    if (categoryId != '1') {
      navigate('../dashboard/')
    }
  }, [categoryId])

  const location = useLocation()
  const [bookingDetails, setBookingDetails] = useState([]) as any
  const [booking, setBooking] = useState({}) as any
  const [userDetail, setUserDetail] = useState({}) as any
  const bookingId = (location.state as any)?.bookingId || ''
  const [preDiscountAmount, setPreDiscountAmount] = useState('') as any
  const [discountPerncentage, setDiscountPercentage] = useState('') as any
  const [couponType, setCouponType] = useState('')
  const [couponValue, setCouponValue] = useState('')

  const formatDate = (date: any) => {
    return moment(date).format('ddd, DD MMM YYYY').toUpperCase()
  }
  // view profile api call
  const bookingDetailsApiCall = async () => {
    var param: any = {
      bookingId: bookingId,
      categoryId: categoryId,
    }

    var response: any = await fetchData('public/bookingDetail', param)

    if (response.status == '200') {
      var data = response.data
      setUserDetail(data[0]['userDetail'][0])
      setBooking(data[0])
      setBookingDetails(data[0]['bookingDetail'])
      setPreDiscountAmount(data[0].discount)
      setDiscountPercentage(data[0]['bookingDetail'][0]?.vendorDiscountPercentage)
      var couponData = data[0]['couponDetail']
      if (Object.keys(couponData).length > 0) {
        setCouponType(couponData['couponType'] ? couponData['couponType'] : '')
        setCouponValue(couponData['couponValue'])
      }
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    bookingDetailsApiCall()
  }, [bookingId])
  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('View Booking Details')}</PageTitle>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>{t('Booking Details')}</h3>
          </div>
        </div>
        <div className='card-body p-9'>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{t('Booking ID')}</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>#{booking['bookingCode']}</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{t('User Name')}</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>{userDetail['fullName']}</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{t('Date Booked')}</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>{formatDate(booking['created'])}</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{t('User Location')}</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>{userDetail['location']}</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{t('Payment Method')}</label>
            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>
                {booking['paymentMethod'] ? booking['paymentMethod'] : ''}
              </span>
            </div>
          </div>
        </div>
      </div>
      {bookingDetails.map((detail: any, index: any) => {
        var primaryLanguage = detail['actionDetail'][0]['primaryLanguage'] || ''
        var hotelName = getTranslatedValue(lang, detail['actionDetail'][0], '_name')
        var roomName = getTranslatedValue(lang, detail['actionTypeDetail'][0], '_roomName')
        var propertyType = detail['actionDetail'][0]['propertyTypeDetail']
          ? getTranslatedValue(
              lang,
              detail['actionDetail'][0]['propertyTypeDetail'][0],
              '_name',
              primaryLanguage
            )
          : ''

        return (
          <div className='card mb-5 mb-xl-10' id='kt_profile_details_view' key={index}>
            <div className='card-header'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{t('Booked Room')}</span>
              </h3>
            </div>
            <div className='card-body p-9'>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Property Type')}</label>

                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>{propertyType}</span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Accomodation Name')}</label>

                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>{hotelName}</span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Room Name')}</label>

                <div className='col-lg-8'>
                  {detail['actionTypeDetail'].map((actionTypeDetail: any, index: any) => {
                    return (
                      <div key={index} className='fw-bolder fs-6 text-dark mt-0'>
                        {getTranslatedValue(lang, actionTypeDetail, '_roomName', primaryLanguage)}
                        {index !== detail['actionTypeDetail'].length - 1 ? ', ' : ''}
                      </div>
                    )
                  })}
                  {/* <span className='fw-bolder fs-6 text-dark'>{roomName}</span> */}
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Total Rooms')}</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {detail['actionTypeDetail'].length}
                  </span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('No Of People')}</label>
                <div className='col-lg-8'>
                  <label className='fw-bold text-muted'>{t('Infant:')}</label>
                  <span className='fw-bolder fs-6 text-dark mx-3'>{detail['infant']}</span>
                  <label className='fw-bold text-muted'>{t('Child:')}</label>
                  <span className='fw-bolder fs-6 text-dark mx-3'>{detail['child']}</span>
                  <label className='fw-bold text-muted'>{t('Adult:')}</label>
                  <span className='fw-bolder fs-6 text-dark mx-3'>{detail['adult']}</span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('By day / By time')}</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {/* {detail['bookingType']
                      ? detail['bookingType']
                      : detail['fromTime'] && detail['toTime']
                      ? t('By Time')
                      : t('By Day')} */}
                    {detail['bookingType'] && detail['bookingType'] == 'byDay'
                      ? t('By Day')
                      : t('By Time')}
                  </span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Check In')}</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {detail['bookingType'] == 'byDay'
                      ? formatDate(detail['fromDate'])
                      : formatDate(detail['fromDate']) + ' ' + detail['fromTime']}
                  </span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Check Out')}</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {detail['bookingType'] == 'byDay'
                      ? formatDate(detail['toDate'])
                      : formatDate(detail['toDate']) + ' ' + detail['toTime']}
                  </span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Length Of Stay')}</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {detail['bookingType'] == 'byDay'
                      ? getNumberOfDays(detail['fromDate'], detail['toDate']) + ` ${t('Days')}`
                      : getNumberOfHoursFromDateTime(
                          detail['fromDate'] + ' ' + detail['fromTime'],
                          detail['toDate'] + ' ' + detail['toTime']
                        ) + ` ${t('Hours')}`}
                  </span>
                </div>
              </div>
              <div className='row'>
                <div className='col-lg-12'>
                  <TablesWidget14
                    className='card-xl-stretch mb-5 mb-xl-8'
                    title={t('Guest Info')}
                    data={detail['guestInfo']}
                  />
                </div>
              </div>
            </div>
          </div>
        )
      })}
      <div className='row'>
        <div className='col-lg-6'>
          <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
            <div className='card-header'>
              <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>{t('Payment Details')}</h3>
              </div>
              <div className='card-title m-0'>
                {booking['status'] == 2 && (
                  <span className='btn btn-light-danger mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>
                    {t('Rejected')}
                  </span>
                )}
                {booking['status'] == 3 && (
                  <span className='btn btn-danger mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>
                    {t('Cancelled')}
                  </span>
                )}
              </div>
            </div>
            <div className='card-body p-9'>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Original Amount')}</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {formatNumber(parseFloat(booking['subTotal']))} UZS
                  </span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Extra People Charge')}</label>
                <div className='col-lg-8'>
                  {/* {/ Total Charge Calculation /} */}
                  <span className='fw-bolder fs-6 text-dark'>
                    {bookingDetails.length > 0 && bookingDetails[0]
                      ? bookingDetails[0].extraPeople &&
                        bookingDetails[0].extraPeople !== '0' &&
                        bookingDetails[0].extraPeopleCharge &&
                        bookingDetails[0].extraPeopleCharge !== '0'
                        ? formatNumber(
                            parseFloat(bookingDetails[0].extraPeopleCharge) *
                              parseFloat(bookingDetails[0].extraPeople)
                          )
                        : 0
                      : '0'}
                    {' UZS'}
                  </span>

                  {/* {/ Breakdown Display /} */}
                  <span className='fw-bolder fs-7 text-dark'>
                    {bookingDetails.length > 0 &&
                    bookingDetails[0] &&
                    bookingDetails[0].extraPeople &&
                    bookingDetails[0].extraPeople !== '' &&
                    bookingDetails[0].extraPeopleCharge &&
                    bookingDetails[0].extraPeopleCharge !== ''
                      ? ` (${bookingDetails[0].extraPeople} x ${formatNumber(
                          bookingDetails[0].extraPeopleCharge
                        )} UZS)`
                      : ' (0 x 0 UZS)'}
                  </span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('User Points')}</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {formatNumber(parseFloat(booking['pointAmount']))} UZS
                  </span>
                  <span className='fw-bold fs-7'> ({booking['point'] + ` ${t('points')}`})</span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Coupon Amount')}</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {booking['couponDiscount'] == '' ||
                    booking['couponDiscount'] == undefined ||
                    booking['couponDiscount'] == null
                      ? 0
                      : formatNumber(parseFloat(booking['couponDiscount']))}{' '}
                  </span>
                  {/* {/ <span className='fw-bold fs-7'> (10% OFF coupon OR 15,000 UZS coupon)</span> /} */}
                  <span className='fw-bolder fs-7 text-dark'>
                    {' '}
                    ({couponValue}{' '}
                    {couponType == 'FIXED'
                      ? t('UZS Coupon')
                      : couponType == 'PERCENTAGE'
                      ? t('% OFF coupon')
                      : t('No Coupon Applied')}
                    )
                  </span>{' '}
                </div>
              </div>
              <div className='row mb-7 pb-5 border-bottom border-gray-300'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Discount Amount')}</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {preDiscountAmount == '' ? 0 : formatNumber(parseFloat(booking['discount']))}
                    {' UZS'}
                  </span>
                  <span className='fw-bolder fs-7 text-dark'>
                    {' '}
                    (
                    {bookingDetails[0] != undefined &&
                    bookingDetails[0] != null &&
                    bookingDetails[0] != '' &&
                    bookingDetails[0].specialDiscount == 0
                      ? discountPerncentage != ''
                        ? discountPerncentage.toFixed(2) + ` % ${t('discount')}`
                        : `0 % ${t('discount')}`
                      : t('Special Discount')}
                    )
                  </span>{' '}
                </div>
              </div>
              {(booking['status'] == 2 || booking['status'] == 3) && (
                <>
                  <div className='row py-3 border-bottom border-gray-300'>
                    <label className='col-lg-4 fw-bold'>{t('Total Paid')}</label>
                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark'>
                        {formatNumber(parseFloat(booking['totalPaid']))} UZS
                      </span>
                    </div>
                  </div>
                  <div className='row py-3 border-bottom border-gray-300 text-danger'>
                    <label className='col-lg-4 fw-bold'>
                      {booking['status'] == 2 ? t('Refundable') : t('Cancellation')} {t('Amount')}
                    </label>
                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6'>
                        -{' '}
                        {formatNumber(
                          parseFloat(booking['bookingDetail'][0]['cancellationAmount'] || 0)
                        )}{' '}
                        UZS
                      </span>
                      <span className='fw-bold fs-7'>
                        {' '}
                        ({booking['bookingDetail'][0]['cancellationCharge'].toFixed(2)}%{' '}
                        {t('refund')})
                      </span>
                    </div>
                  </div>
                </>
              )}
              <div className='row my-7'>
                <label className='col-lg-4 fw-bold fs-6'>{t('Final Amount')}</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {formatNumber(parseFloat(booking['totalAmount']))} UZS
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-lg-6'>
          <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
            <div className='card-header'>
              <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>{t('Insayr Commission')}</h3>
              </div>
            </div>
            <div className='card-body p-9'>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('INSAYR Service Fee')}</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {booking['insayrServiceRate']
                      ? parseFloat(booking['insayrServiceRate']).toFixed(2)
                      : '0.00'}
                    %
                  </span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('INSAYR Service Amount')}</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {booking['insayrServiceFee']
                      ? formatNumber(parseFloat(booking['insayrServiceFee']))
                      : '0'}{' '}
                    UZS
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {ViewHotelBookingDetails}
